import { Link, Paper, Stack, SxProps, Theme, Typography, TypographyProps } from "@mui/material"
import React from "react"
import { TitleFont } from "src/theme"

interface MyCardProps {
  children: React.ReactNode
  direction?: "row" | "row-reverse"
  gap?: number
  sx?: SxProps<Theme>
  variant?: "transparent" | "colorful"
}

export function MyCard({
  children,
  variant = "transparent",
  direction = "row",
  gap = 12,
  sx,
}: MyCardProps) {
  return (
    <Paper
      sx={{
        ...(variant === "transparent"
          ? { background: "transparent" }
          : {
              background:
                "linear-gradient(45deg, rgba(216, 216, 216, 0.36) 0%, rgba(0,0,0,0) 25%, rgb(255, 255, 255) 50%,#f7dbff 65%, rgba(255, 255, 255, 0) 100%)",
              border: 0,
              "html.dark &": {
                background:
                  "linear-gradient(45deg, rgba(0,0,0,0) 0%, rgb(18,18,18) 25%, rgb(18,18,18) 50%, rgba(123,28,186,0.31) 65%, rgba(0,0,0,0) 100%)",
              },
            }),
        border: 0,
        padding: 4,
        ...sx,
      }}
      transparent="off"
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        direction={{
          sm: direction,
          xs: "column",
        }}
        gap={{
          lg: gap,
          sm: gap / 2,
          xs: 0,
        }}
      >
        {children}
      </Stack>
    </Paper>
  )
}

export function MyCardTitle({ id, ...rest }: TypographyProps) {
  return (
    <Typography
      sx={{ display: "block", fontVariationSettings: "'GRAD' 150" }}
      variant="h4"
      fontWeight={500}
      fontFamily={TitleFont}
      textAlign="center"
      href={id ? `#${id}` : undefined}
      id={id}
      component={id ? Link : "h4"}
      underline="hover"
      {...rest}
    />
  )
}

export function MyCardDescription(props: TypographyProps) {
  return (
    <Typography
      variant="body1"
      color="text.secondary"
      marginTop={-2}
      textAlign="center"
      component="div"
      {...props}
    />
  )
}
